import { Text, View } from '@react-pdf/renderer';

import { createPdfStyles } from '../utils/create-pdf-styles';

import { styles as sharedStyles } from './syllabus-styles';

type SyllabusPrerequisitesProps = {
  prerequisites: string[];
};

const styles = createPdfStyles({
  skillTextPill: {
    ...sharedStyles.pillContainer,
    borderColor: '#7D8AA8',
    borderWidth: '1px',
  },
  skillTextPillText: {
    fontFamily: 'Inter',
    fontSize: '12px',
    color: 'blue.500',
    fontWeight: 600,
  },
  badgesRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
    marginVertical: 8,
    width: '100%',
  },
});

const NO_PRE_REQUISITES_TEXT = 'No required prerequisites.';
const PRE_REQUISITES_TEXT = 'Prior to enrolling, you should have the following knowledge:';

export function SyllabusPrerequisites(props: SyllabusPrerequisitesProps) {
  const { prerequisites } = props;
  const hasPrerequisites = prerequisites.length > 0;
  return (
    <View style={sharedStyles.section}>
      <Text style={sharedStyles.sectionTitle}>Prerequisites</Text>
      <Text style={sharedStyles.text}>{hasPrerequisites ? PRE_REQUISITES_TEXT : NO_PRE_REQUISITES_TEXT}</Text>
      {hasPrerequisites && (
        <View style={styles.badgesRow}>
          {prerequisites.map((prerequisite) => (
            <SkillText key={prerequisite} text={prerequisite} />
          ))}
        </View>
      )}
      <Text style={sharedStyles.text}>
        You will also need to be able to communicate fluently and professionally{' '}
        <Text style={sharedStyles.emphasis}>in written and spoken English</Text>.
      </Text>
    </View>
  );
}

function SkillText(props: { text: string }) {
  const { text } = props;
  return (
    <View style={styles.skillTextPill}>
      <Text style={styles.skillTextPillText}>{text}</Text>
    </View>
  );
}
